export const UNSAVED_VEHICLE_KEY = 'unsaved_vehicle_data';
export const UNSAVED_SEND_OPTIONS_KEY = 'unsaved_send_options_data';
export const UNSAVED_PRICE_KEY = 'unsaved_price_data';
export const EXISTING_REPORT_VEHICLE_KEY = 'existing_vehicle_data';
export const EXISTING_REPORT_SEND_OPTIONS_KEY = 'existing_send_options_data';
export const EXISTING_REPORT_PRICE_KEY = 'existing_price_data';
export const PROVIDER_DATA_KEY = 'provider_data';
export const IS_RETURNING_USER = 'is_returning_user';
export const KNOWS_COOKIES = 'accept_cookies';

